import publicApi from './publicApi'

// Mirrors services/charting.js but against the public, unauthenticated
// namespace (/api/public/*). Read-only, same shape as the private endpoints
// so the standalone chart can reuse the same response-parsing code.
export const publicChartingService = {
  getHistory: (params, options) => publicApi.get('/candles', { params, ...options }),
  // Vela viva de la vista Bitunix (polling REST 5 s, sin WS — D-5).
  getLiveCandles: (params, options) => publicApi.get('/candles/live', { params, ...options }),
  // Pares listados en Bitunix (compactos, BTCUSDT). 503 si Bitunix no responde.
  getBitunixSymbols: () => publicApi.get('/symbols/bitunix'),
  searchSymbols: (query = '', exchange = 'bingx', source = 'crypto') =>
    publicApi.get('/symbols', { params: { query, exchange, source } }),
  getICT: (params, options) => publicApi.get('/indicators/ict', { params, ...options }),
  getFVGIFVG: (params, options) => publicApi.get('/indicators/fvg-ifvg', { params, ...options }),
  getOrderBlocks: (params, options) => publicApi.get('/indicators/order-blocks', { params, ...options }),
  getMitigationBlocks: (params, options) => publicApi.get('/indicators/mitigation-blocks', { params, ...options }),
  // Liquidity Pools Quantum (canon v1.0: endpoint dedicado, sin config params)
  getLiquidityPools: (params, options) => publicApi.get('/indicators/liquidity-pools', { params, ...options }),
  getInternalIndicators: (params, options) => publicApi.get('/indicators', { params, ...options }),
  getOrderflowQuantum: (params, options) => publicApi.get('/indicators/orderflow-quantum', { params, ...options }),
  getOrderflowQuantumStats: (params, options) => publicApi.get('/indicators/orderflow-quantum/stats', { params, ...options }),
  getICTSignal: (params, options) => publicApi.get('/ict/signal', { params, ...options }),
  // Estado oficial de la señal SuperTrend Quantum abierta (Redis signal_card)
  getSuperTrendSignal: (params, options) => publicApi.get('/indicators/supertrend/signal', { params, ...options }),
  // `include` no se manda — /api/public/playback lo fija en servidor a solo
  // estructura de mercado descriptiva (ver backend/.../public/data.py).
  getPlaybackData: ({ symbol, timeframe, from_time, to_time }) =>
    publicApi.post('/playback', { symbol, timeframe, from_time, to_time }),
}
